(() => {
 const video=document.querySelector('.slp-intro video');
 if(!video||video.dataset.tgPlaybackReady)return;
 video.dataset.tgPlaybackReady='true';
 video.controls=false;
 video.muted=true;
 video.defaultMuted=true;
 video.playsInline=true;
 video.loop=true;
 const cart=document.getElementById('TsukiCart');
 let playPending=false,retries=0,retryTimer;
 const shouldPlay=()=>{
  const rect=video.getBoundingClientRect();
  const visibleHeight=Math.min(rect.bottom,window.innerHeight)-Math.max(rect.top,0);
  return rect.height>0&&visibleHeight>=rect.height*.15&&!document.hidden&&!cart?.open;
 };
 const syncPlayback=()=>{
  if(!shouldPlay()){clearTimeout(retryTimer);video.pause();return;}
  if(playPending||!video.paused)return;
  playPending=true;
  video.play().then(()=>{
   retries=0;
   if(!shouldPlay())video.pause();
  }).catch(()=>{

   if(shouldPlay()&&retries++<3)retryTimer=setTimeout(syncPlayback,250);
  }).finally(()=>{playPending=false;});
 };
 const observer=new IntersectionObserver(()=>{
  retries=0;
  syncPlayback();
 },{threshold:[0,.15]});
 observer.observe(video);
 const preloadObserver=new IntersectionObserver(([entry])=>{
  if(!entry.isIntersecting)return;
  video.preload='auto';
  preloadObserver.disconnect();
 },{rootMargin:'400px'});
 preloadObserver.observe(video);
 video.addEventListener('loadeddata',syncPlayback);
 video.addEventListener('canplay',syncPlayback);
 video.addEventListener('play',()=>{if(!shouldPlay())video.pause();});
 video.addEventListener('pause',()=>{
  if(shouldPlay()&&retries++<3)retryTimer=setTimeout(syncPlayback,250);
 });

 window.addEventListener('pointerdown',syncPlayback,{passive:true});
 window.addEventListener('keydown',syncPlayback);
 window.addEventListener('focus',syncPlayback);
 if(cart)new MutationObserver(()=>{retries=0;syncPlayback();}).observe(cart,{attributes:true,attributeFilter:['open']});
 document.addEventListener('visibilitychange',syncPlayback);
 window.addEventListener('pagehide',()=>video.pause());
 window.addEventListener('pageshow',syncPlayback);
 syncPlayback();
})();
